import React, { useState } from 'react';


import { AppWrapp, MotionWrap } from '../../wrapper';

import { client } from '../../client';

import { images } from '../../constants';

import './Footer.scss';

const Footer = () => {
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		message: '',
	});
  const [loading, setLoading] = useState(false);
  const [isFormSubmited, setIsFormSubmited] = useState(false);

	const { name, email, message } = formData;

	const handleChangeInput = (e) => {
		const { name, value } = e.target;

		setFormData({ ...formData, [name]: value });
	};

	const handlerSubmit = () => {
		setLoading(true);

		const contact = {
			_type: 'contact',
			name: name,
			email: email,
			message: message,
    };
    
    client.create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmited(true)
    })
	};

	return (
		<>
			<h2 className='head-text'>Take a coffe & chant with me </h2>

			<div className='app__footer-cards'>
				<div className='app__footer-card'>
					<img src={images.email} alt='email' />
					<a href='mailto:ckarungu921@gmail.com' className='p-text'>
						ckarungu921@gmail.com
					</a>
				</div>
				<div className='app__footer-card'>
					<img src={images.email} alt='mobile' />
					<a href='tel:+243970301036' className='p-text'>
						243970301036
					</a>
				</div>
      </div>
      {!isFormSubmited ?
      
        <div className='app__footer-form app__flex'>
          <div className='app__flex'>
            <input
              type='text'
              placeholder='your name'
              name='name'
              value={name}
              onChange={handleChangeInput}
            />
          </div>
          <div className='app__flex'>
            <input
              type='email'
              placeholder='your email'
              name='email'
              value={email}
              onChange={handleChangeInput}
            />
          </div>
          <div>
            <textarea
              name='message'
              placeholder='your message'
              value={message}
              onChange={handleChangeInput}
            ></textarea>
          </div>
          <button type='submit' class='p-text' onClick={handlerSubmit}>
            {loading ? 'SENDING' : 'Submit'}
          </button>
        </div>
        :
        <div>
          <h3 className="head-text">Thanks you for getting started with me</h3>
        </div>
      }
		</>
	);
};

export default AppWrapp(
	MotionWrap(Footer, 'app__testimonial'),
	'contact',
	'app__whitebg'
);
